import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { PersistGate } from 'redux-persist/integration/react'
// import from store.js
import { store, persistor } from './store'
import { Provider } from "react-redux";
import PublicSite from "./staticSite/PublicSite";
import Signin from "./react-redux/components/Signin";
import AdminPage from "./react-redux/components/admin/AdminPage";
import TeacherLandingPage from "./react-redux/components/teacher/TeacherLandingPage";
import "./staticSite/public-site.css";
function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Routes>
            <Route exact path="/" element={<PublicSite page="home" />} />
            <Route path="/contact" element={<PublicSite page="contact" />} />
            <Route path="/about" element={<PublicSite page="about" />} />
            <Route path="/admissions" element={<PublicSite page="admissions" />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/teacher" element={<TeacherLandingPage />} />
          </Routes>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
